// @flow
import React from 'react';
import { CLUSTER_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { SelectField } from '@src/formik-utils/FormFields';
import {
  AWS,
  MULTI_NETWORKING_TYPE_SUPPOERTED_CLUSTER_TYPES,
  PNI,
  PNI_DISPLAY_NAME,
  PRIVATE_LINK,
  PRIVATE_LINK_DISPLAY_NAME,
} from '@src/constants';

import { CLUSTER_WORKLOAD_DETAILS_CONFIG_MAP } from '../config';
import { useSPClusterWorkloadContext } from '../contexts/SPClusterWorkloadContextProvider';

const getClusterWorkloadNetworkingTypeOptions = (provider) => {
  // todo::SP Remove these hardcoded dropdown options and get it from BE
  const privateLinkOption = {
    name: PRIVATE_LINK,
    display_name: PRIVATE_LINK_DISPLAY_NAME,
  };
  const pniOption = {
    name: PNI,
    display_name: PNI_DISPLAY_NAME,
  };
  return provider === AWS ? [privateLinkOption, pniOption] : [privateLinkOption];
};

export const SPClusterWorkloadNetworkingTypeContainer = ({ disabled }) => {
  const clusterWorkloadNetworkingTypeConfig = CLUSTER_WORKLOAD_DETAILS_CONFIG_MAP.get(
    CLUSTER_WORKLOADS_INPUTS_FIELDNAMES.CLUSTER_WORKLOAD_NETWORKING_TYPE
  );

  const spClusterWorkloadData = useSPClusterWorkloadContext();
  const clusterType = spClusterWorkloadData.cluster_resource_details.cluster_type;
  const provider = spClusterWorkloadData.cluster_resource_details.provider;

  // Only show this dropdown for Clusters where MULTI Networking Type is supported
  const shouldShowNetworkingType =
    MULTI_NETWORKING_TYPE_SUPPOERTED_CLUSTER_TYPES.includes(clusterType);

  if (!shouldShowNetworkingType) {
    return null;
  }

  const clusterWorkloadNetworkingTypeOptions = getClusterWorkloadNetworkingTypeOptions(provider);

  return (
    <SelectField
      disabled={disabled}
      fieldDisplayName={clusterWorkloadNetworkingTypeConfig.displayName}
      fieldName={clusterWorkloadNetworkingTypeConfig.backendFieldName}
      options={clusterWorkloadNetworkingTypeOptions}
      placeholder={null}
    />
  );
};
